import { PageHeader } from './page-header';
import { allowedChildren, type Can, type NavGroup, type NavLinkComponent } from './types';

type Props = { group: NavGroup; can: Can; Link: NavLinkComponent };

// a group's own page when it has nothing else to show: the pages under it as cards, under their headings, so
// every page can be reached from here as well as from the menu
export function SectionHub({ group, can, Link }: Props) {
  const children = allowedChildren(group, can);
  const titles = [...new Set(children.map((item) => item.group))];
  return (
    <section>
      <PageHeader title={group.label} description={group.description} />
      {titles.map((title, index) => (
        <div className="admin-hub-part" key={title ?? index}>
          {title && <h2 className="admin-hub-title">{title}</h2>}
          <div className="admin-hub">
            {children
              .filter((item) => item.group === title)
              .map(({ path, label, icon: Icon, description }) => (
                <Link key={path} to={path} className="admin-hub-card">
                  <Icon aria-hidden className="admin-hub-icon" />
                  <strong>{label}</strong>
                  {description && <span>{description}</span>}
                </Link>
              ))}
          </div>
        </div>
      ))}
    </section>
  );
}
